import { render, staticRenderFns } from "./transparentLogo1.vue?vue&type=template&id=e3830592"
import script from "./transparentLogo1.vue?vue&type=script&lang=js"
export * from "./transparentLogo1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports